import React from "react";
import TableRow from "./TableRow";
import "./Table.css"

const Table = ({ theadData, tbodyData, customClass }) => {
    return (
        <table className={customClass}>
            <thead >
                <tr>
                    <th colSpan="3">{theadData}</th>
                </tr>
            </thead>
            <tbody>
                {tbodyData.map((item,index) => {
                    return <TableRow key={index} data={item.items} />;
                })}
            </tbody>
        </table>
    );
};

export default Table;